import { render, staticRenderFns } from "./RelationsChart2.component.vue?vue&type=template&id=e36b8a7a&"
import script from "./RelationsChart2.component.vue?vue&type=script&lang=js&"
export * from "./RelationsChart2.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports